import React from "react";
import { Col } from "antd";
import { textTitleHome } from "../../config/constant/color/index";

const HomeTitle = ({
  textTitle,
  attrTextTitle,
  usrDataName,
  dynamic,
  isMobileVersion = false,
}) => {
  return (
    <>
      <Col span={18}>
        <div
          className="general-title"
          text-title={
            attrTextTitle !== undefined ? attrTextTitle : "default-title"
          }
          style={{
            fontSize:
              dynamic === true && usrDataName === undefined
                ? "inherit"
                : isMobileVersion
                ? "18px"
                : "22px",
            textAlign: "left",
            fontWeight: "500",
            color: textTitleHome,
            lineHeight: isMobileVersion ? "100%" : "unset",
          }}
        >
          {textTitle}
        </div>
      </Col>
      <Col span={6}></Col>
    </>
  );
};

export default HomeTitle;
